const endpoints = {
  account: {
    authorize: '/authorize',
    token: '/api/token',
  },
  api: {
    playlists: '/playlists',
  },
};

export default endpoints;
